import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

if (process.env.NODE_ENV != "development") {
  Sentry.init({
    dsn: Laravel.sentrydsn,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: "WWW"
  });
}

import CustomerChat from "@/components/Customer/chat/CustomerChat.vue";
Vue.component("customer-chat", CustomerChat);

import Logout from "@/components/Logout.vue";
Vue.component("Logout", Logout);

import CenterBox from "@/components/CenterBox.vue";
Vue.component("center-box", CenterBox);

import Signup from "@/components/Signup.vue";
Vue.component("signup", Signup);

import BuyCoinsPage from "@/components/BuyCoinsPage.vue";
Vue.component("buy-coins-page", BuyCoinsPage);

import UserProfile from "@/components/Customer/UserProfile.vue";
Vue.component("user-profile", UserProfile);

import NavBarDropDown from "@/components/Customer/NavBarDropDown.vue";
Vue.component("navbar-dropdown", NavBarDropDown);

import CustomerMenu from "@/components/Customer/CustomerMenu.vue";
Vue.component("customer-menu", CustomerMenu);

import MessageForm from "@/components/MessageForm.vue";
Vue.component("message-form", MessageForm);

import QuotedBox from "@/components/Customer/QuotedBox.vue";
Vue.component("textbox-quoted", QuotedBox);

import CustomSelect from "@/components/CustomSelect.vue";
Vue.component("custom-select", CustomSelect);

import UserSearchBox from "@/components/Customer/UserSearchBox.vue";
Vue.component("user-search-box", UserSearchBox);

import UserSearchResult from "@/components/Customer/UserSearchResult.vue";
Vue.component("user-search-result", UserSearchResult);

import UserShortInfoBox from "@/components/Customer/UserShortInfoBox.vue";
Vue.component("user-short-info", UserShortInfoBox);

import vueSlider from "vue-slider-component";
Vue.component("vue-slider", vueSlider);

import DistanceMap from "@/components/Customer/DistanceMap.vue";
Vue.component("distance-map", DistanceMap);

import ProposedMembers from "@/components/Customer/ProposedMembers.vue";
Vue.component("proposed-members", ProposedMembers);

import ConfirmModal from "@/components/Customer/ConfirmModal.vue";
Vue.component("confirm-modal", ConfirmModal);

import Switch from "@/components/Switch.vue";
Vue.component("toggle-switch", Switch);

import Resource from "@/components/Resource.vue";
Vue.component("resource", Resource);

import Button from "@/components/Button.vue";
Vue.component("v-button", Button);

import BurgerMenu from "@/components/Customer/BurgerMenu.vue";
Vue.component("burger-menu", BurgerMenu);

import ColLabel from "@/vue-paper-dashboard-pro-2/components/Dashboard/Views/Components/ColLabel.vue";
Vue.component("col-label", ColLabel);

import CustomerUpload from "@/components/Customer/Upload.vue";
Vue.component("customer-upload", CustomerUpload);

import CustomerMedia from "@/components/Customer/Media.vue";
Vue.component("customer-media", CustomerMedia);

import ProfileImages from "@/components/Customer/profile/Images.vue";
Vue.component("profile-images", ProfileImages);

import ProfileAudio from "@/components/Customer/profile/Audio.vue";
Vue.component("profile-audio", ProfileAudio);

import VueSlideUpDown from "vue-slide-up-down";
Vue.component("vue-slide-up-down", VueSlideUpDown);

import UserRecordAudio from "@/components/Customer/UserRecordAudio.vue";
Vue.component("record-audio", UserRecordAudio);

import MediaEntry from "@/components/Customer/MediaEntry.vue";
Vue.component("media-entry", MediaEntry);

import FriendsOnline from "@/components/Customer/FriendsOnline.vue";
Vue.component("friends-online", FriendsOnline);

import UserDeletion from "@/components/Customer/UserDeletion.vue";
Vue.component("user-deletion", UserDeletion);

import CurrentBalance from "@/components/Customer/CurrentBalance.vue";
Vue.component("current-balance", CurrentBalance);

import ProfileNameSearch from "@/components/Customer/ProfileNameSearch.vue";
Vue.component("profile-name-search", ProfileNameSearch);

import PublicProfileModal from "@/components/Customer/PublicProfileModal.vue";
Vue.component("public-profile-modal", PublicProfileModal);

import ImageModal from "@/components/ImageModal.vue";
Vue.component("image-modal", ImageModal);

import UploadModal from "@/components/UploadModal.vue";
Vue.component("upload-modal", UploadModal);

import CompleteProfileModal from "@/components/CompleteProfileModal.vue";
Vue.component("complete-profile-modal", CompleteProfileModal);

import CookieModal from "@/components/modals/CookieModal.vue";
Vue.component("cookie-modal", CookieModal);

import UserEmailPasswordForm from "@/components/Customer/UserEmailPasswordForm.vue";
Vue.component("user-email-password-form", UserEmailPasswordForm);

import ImageProfileBox from "@/components/Customer/ImageProfileBox.vue";
Vue.component("image-profile-box", ImageProfileBox);

import ProfileVisits from "@/components/ProfileVisits.vue";
Vue.component("profile-visits", ProfileVisits);

import CustomerSettingsNavigation from "@/components/Customer/settings/Navigation.vue";
Vue.component("customer-settings-navigation", CustomerSettingsNavigation);

import CustomerFriends from "@/components/Customer/Friends.vue";
Vue.component("customer-friends", CustomerFriends);

import FriendsInfoBox from "@/components/Customer/FriendsInfoBox.vue";
Vue.component("friends-info-box", FriendsInfoBox);

import CustomerNews from "@/components/Customer/News.vue";
Vue.component("customer-news", CustomerNews);

import CustomerNewsArticle from "@/components/Customer/NewsArticle.vue";
Vue.component("customer-news-article", CustomerNewsArticle);

import AffiliateConfirmationModal from "@/components/Customer/AffiliateConfirmationModal.vue";
Vue.component("affiliate-confirmation-modal", AffiliateConfirmationModal);

const requireComponent = require.context(
  "@/templates",
  true,
  /(Signup|CustomerStats).vue$/
);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  let parts = fileName.split("/");
  let file = parts[parts.length - 1].replace(/\.\w+$/, "");
  let folder = parts[parts.length - 2];
  const componentName = upperFirst(file) + upperFirst(folder);

  Vue.component(componentName, componentConfig.default || componentConfig);
});
